import { IntlShape } from 'react-intl';

import { FACET } from '@app/components';
import { LocationDto } from '@app/hooks';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';
import { getLocationOptions } from './getLocationOptions';
import { getLanguageOptions } from './getLanguageOptions';

interface FacetMappingValueProps {
  facetName: string;
  values: UnmappedFacetValue[];
  locations?: LocationDto[];
  $t: IntlShape['$t'];
}

export const getMappedFacetValues = ({
  $t,
  facetName,
  values,
  locations,
}: FacetMappingValueProps): MappedFacetValue[] => {
  switch (facetName) {
    case FACET.LANGUAGE:
      return getLanguageOptions($t, values);
    case FACET.LOCATION:
      return getLocationOptions(locations, values);
    default:
      return values.map(({ id, totalRecords }) => ({
        label: id,
        value: id,
        id,
        count: totalRecords,
      }));
  }
};
